import { render, staticRenderFns } from "./GiftList.vue?vue&type=template&id=f19d94fc&scoped=true"
import script from "./GiftList.vue?vue&type=script&lang=js"
export * from "./GiftList.vue?vue&type=script&lang=js"
import style0 from "./GiftList.vue?vue&type=style&index=0&id=f19d94fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19d94fc",
  null
  
)

export default component.exports